
import React from "react";
const InvestmentsIcon = (props) => {
  return (
    <div></div>
  );
}
export default InvestmentsIcon;
